<template>
  <div class="iframe-container">
    <iframe 
      :src="externalUrl" 
      id="powerBIcontainer" 
      frameborder="1" 
      allowfullscreen>
    </iframe>
  </div>
</template>

<style scoped>
  .iframe-container {
    width: 100%;
    height: 100vh; /* altura completa */
  }

  .iframe-container iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
</style>

<script>
export default {
  name: "DashboardVendors",
  setup() {

  },
  data() {
    return {
      externalUrl: ""
    }
  },
  components: {
  },
  methods: {
  },
  computed: {
  },
  mounted() {
    // let filtro;

    // if (this.$store.state.user.data.tipo_Empleado === "A") {
    //   filtro = `Tipo_Personal eq "A"`;
    // } else if (this.$store.state.user.data.tipo_Empleado === "V") {
    //   filtro = `Identificacion eq "${this.$store.state.user.data.id_Empleado}"`;
    // } else if (this.$store.state.user.data.tipo_Empleado === "D") {
    //   filtro = `Grupo eq "${this.$store.state.user.data.id_Empleado}"`;
    // }
    



    // this.$store.state.user.data.tipo_Empleado === "D" ? this.$store.state.user.data.idStaffGroup : null,
    // this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : null

    // this.externalUrl = `https://app.powerbi.com/reportEmbed?reportId=43c5cb48-1236-43c4-82cc-f2095d3c3452&autoAuth=true&ctid=e6805558-f5bb-444c-8af2-5f3a4d6dd3fc&filter=Empleados/${filtro}&filterPaneEnabled=false`;
    this.externalUrl = `https://app.powerbi.com/reportEmbed?reportId=f77e1302-b74d-45f5-b22e-633040a5bdd4&autoAuth=true&ctid=e6805558-f5bb-444c-8af2-5f3a4d6dd3fc&filterPaneEnabled=false`;

    console.log("Ingreso al dashboard de BI ", this.externalUrl);
  }
}
</script>
